<div class="px-5 pb-5">
  <div class="mt-4">
    <span class="collapsible cursorPointer" (click)="toggleDeviceInfo()">
      {{ ("DEVICE" | translate | uppercase) + " " + ("INFORMATION" | translate | uppercase) }}
      <i class="fa-regular ml-2"
      [ngClass]="deviceInfoCollapseState === 'expanded' ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </span>

    <div class="deviceInfoGrid expandContainer" [@expandCollapseDetails]="deviceInfoCollapseState">
      <div class="d-flex">
        <p>{{ "STATUS" | translate}}:</p>
        <app-feature-badge [feature]="device | resolveDeviceStatus"></app-feature-badge>
      </div>

      <p>{{ "NAME" | translate}}: <span>{{ device.deviceName || "-" }}</span></p>
      <p>{{ "LOCATION" | translate}}: <span>{{ device.company || "-" }}</span></p>
      <p>{{ "SERIAL_NUMBER" | translate}}: <span>{{ device.devId || "-" }}</span></p>

      @if (batteryStatus) {
        <div class="d-flex">
          <p>{{ "BATTERY_STATUS" | translate}}:</p>
          <span class="fa-solid fa-fw fa-lg align-self-center ml-1"
            [ngClass]="batteryStatus | batteryIcon"
          [matTooltip]="(batteryStatus === 4 || batteryStatus === 5) ? ('BATTERY_INFO_TEXT' | translate) : null"></span>
        </div>
      }

      <p>{{ "DEVICE_SOFTWARE_VERSION" | translate}}: <span>{{ device.swrel || "-" }}</span></p>
      @if (batteryStatus) {
        <p></p>
      }
      <p>GSM: <span>{{ device.gsmNumber || "-" }}</span></p>
    </div>
  </div>

  <hr class="mt-1" />

  <div>
    <span class="collapsible cursorPointer" (click)="toggleCareRecipient()">
      {{ "CARE_RECIPIENT" | translate | uppercase }}
      <i class="fa-regular ml-2"
      [ngClass]="careRecipientCollapseState === 'expanded' ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </span>

    <div class="expandContainer careRecipientInfo" [@expandCollapseDetails]="careRecipientCollapseState">
      <p>{{ "NAME" | translate}}: <span>{{ device.resident || "-" }}</span></p>
      <p>{{ "SSNUMBER" | translate}}: <span>{{ device.sSnumber || "-" }}</span></p>
      <p>{{ "ADDRESS" | translate}}: <span>{{ device.locationAddress || "-" }}</span></p>
    </div>
  </div>

  <hr />

  <div>
    <span class="collapsible cursorPointer" (click)="toggleDeviceHistory()">
      {{ "HISTORY" | translate | uppercase }}
      <i class="fa-regular ml-2"
      [ngClass]="deviceHistoryCollapseState === 'expanded' ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </span>

    <div class="deviceHistoryExpandContainer" [@expandCollapseDetails]="deviceHistoryCollapseState">
      @if (deviceHistoryLoading) {
        <mat-spinner diameter="30" class="m-2"></mat-spinner>
      } @else if (errorMsg) {
        <div class="alert alert-danger" style="margin-bottom: 0;" role="alert">
          {{ errorMsg | translate }}
        </div>
      } @else if (deviceHistory?.events.length > 0) {
        <app-device-history-logs
        [historyEvents]="deviceHistory.events"></app-device-history-logs>
      } @else {
        <div class="alert alert-info" style="margin-bottom: 0;" role="alert">
          {{ "NO_HISTORY" | translate }}
        </div>
      }

    </div>
  </div>
</div>